<template>
  <div id="root">
    <modal
      :show="show"
      @close="editRecordId = null; $emit('close')"
      modal-classes="modal-lgest"
    >
      <div slot="header">
        <h4>
          Completed Grad Forms
        </h4>
        <p class="text-center" style="margin:0;">
          <CircleButton
            disabled
            icon
            round
            class="green"
          >
            {{ completeGrads.length }}
          </CircleButton>
        </p>
      </div>
      <div
        class="list-group-item min-padding card"
        v-for="record in completeGrads"
        :key="record.id"
      >
        <Form
          :record="record"
          :editing="record.id === editRecordId"
          :allow-editing="editRecordId === null"
          :graduation-month-options="graduationMonthOptions"
          @setEditRecordId="setEditRecordId($event)"
          @setGraduationRecords="setGraduationRecords($event); editRecordId = null;"
        />
      </div>
    </modal>
  </div>
</template>

<script>
import modal from '../UIComponents/Modal.vue';
import Form from './Form.vue';
import CircleButton from '../UIComponents/Button.vue';
import { RepositoryFactory } from '../../repositories/repositoryFactory';

const GraduationRecordsRepository = RepositoryFactory.get('graduationRecords');

export default {
    name: 'CompletedFormsModal',
    components: {
        modal,
        Form,
        CircleButton
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        completeGrads: {
            type: Array,
            default: null
        },
        graduationMonthOptions: {
            type: Array,
            default() { return [2021]; }
        },
        graduationYearOptions: {
            type: Array,
            default: null
        }
    },
    data() {
        return {
            editRecordId: null
        };
    },
    computed: {
        countCompleteGrads() {
            return this.completeGrads.length;
        },
    },
    methods: {
        setEditRecordId(editRecordId) {
            this.editRecordId = editRecordId;
        },
        setGraduationRecords(event) {
            this.$emit('setGraduationRecords', event);
        }
    },
};
</script>
